import { galleryImages } from '../../../mocks/homeData';

export default function Gallery() {
  return (
    <section className="bg-[#0A0A0A] py-28" id="gallery">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="text-[#FF6B35] text-xs font-black uppercase tracking-[0.2em] mb-3 flex items-center gap-2">
              <span className="w-6 h-px bg-[#FF6B35]" />
              Our Work
            </span>
            <h2 className="font-display font-black text-5xl lg:text-6xl text-white leading-tight">
              Recent Vehicle
              <br />
              <span className="text-[#FF6B35]">Protection Projects</span>
            </h2>
          </div>
          <p className="text-gray-500 text-base max-w-sm leading-relaxed">
            Real results on real vehicles. Every project is a testament to our precision, passion, and commitment to perfection.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-12 gap-4" style={{ gridTemplateRows: '280px 260px' }}>
          <div className="col-span-7 row-span-1 rounded-2xl overflow-hidden group relative cursor-pointer">
            <img src={galleryImages[0].src} alt={galleryImages[0].alt}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <GalleryOverlay label={galleryImages[0].label} />
          </div>
          <div className="col-span-5 row-span-1 rounded-2xl overflow-hidden group relative cursor-pointer">
            <img src={galleryImages[1].src} alt={galleryImages[1].alt}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <GalleryOverlay label={galleryImages[1].label} />
          </div>
          <div className="col-span-4 row-span-1 rounded-2xl overflow-hidden group relative cursor-pointer">
            <img src={galleryImages[2].src} alt={galleryImages[2].alt}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <GalleryOverlay label={galleryImages[2].label} />
          </div>
          <div className="col-span-3 row-span-1 rounded-2xl overflow-hidden group relative cursor-pointer">
            <img src={galleryImages[3].src} alt={galleryImages[3].alt}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <GalleryOverlay label={galleryImages[3].label} />
          </div>
          <div className="col-span-5 row-span-1 rounded-2xl overflow-hidden group relative cursor-pointer">
            <img src={galleryImages[4].src} alt={galleryImages[4].alt}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <GalleryOverlay label={galleryImages[4].label} />
          </div>
        </div>

        <div className="flex items-center justify-between mt-8">
          <p className="text-gray-600 text-sm"><strong className="text-white/60">BMW, Porsche, Ferrari, Tesla, Lamborghini</strong> — and everything in between.</p>
          <a href="/gallery"
            className="inline-flex items-center gap-2 border border-white/20 hover:border-white/50 text-white font-bold px-7 py-3.5 rounded-xl transition-colors whitespace-nowrap cursor-pointer text-sm">
            Full Gallery
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
          </a>
        </div>
      </div>
    </section>
  );
}

function GalleryOverlay({ label }: { label: string }) {
  return (
    <>
      <div className="absolute inset-0 bg-[#050505]/0 group-hover:bg-[#050505]/55 transition-colors duration-300 flex items-center justify-center">
        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] rounded-full mx-auto">
            <i className="ri-eye-line text-white text-xl" />
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent">
        <span className="text-white text-sm font-bold">{label}</span>
      </div>
    </>
  );
}
